import { localNow } from "@/filters/DateAndTime";
import { Component, Vue } from "vue-property-decorator";
import {
  CLOCK_DATE_FORMAT,
  CLOCK_DATE_FORMAT_MOBILE,
  CLOCK_TIME_FORMAT,
  CLOCK_TIME_FORMAT_MOBILE
} from "../shared/util";

const CLOCK_UPDATE_INERVAL = 500;

@Component({
  components: {}
})
export default class Clock extends Vue {
  currentTime: any = null;
  interval: any = null;

  get isMobile() {
    return (
      this.$vuetify.breakpoint.smAndDown && this.$vuetify.breakpoint.width < 460
    );
  }

  get isMobileThin() {
    return (
      this.$vuetify.breakpoint.smAndDown && this.$vuetify.breakpoint.width < 380
    );
  }

  // Current date for display in upper right
  get CurrentDate(): string {
    return this.currentTime !== null
      ? this.currentTime.format(
          !this.isMobile ? CLOCK_DATE_FORMAT : CLOCK_DATE_FORMAT_MOBILE
        )
      : "";
  }
  // Current time for display in upper right
  get CurrentTime(): string {
    return this.currentTime !== null
      ? this.currentTime.format(
          !this.isMobile ? CLOCK_TIME_FORMAT : CLOCK_TIME_FORMAT_MOBILE
        )
      : "";
  }

  get CurrentMiltTime(): string {
    return this.currentTime !== null ? this.currentTime.format("HH:mm") : "";
  }
  async mounted() {
    this.updateClock();
    if (!this.interval) {
      this.interval = setInterval(() => {
        this.updateClock();
      }, CLOCK_UPDATE_INERVAL);
    }
  }

  updateClock() {
    this.currentTime = localNow();
  }
}
